import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const DirSaleTrendGraph = ({ formValues, totalValues }) => {

  let { invPeriodId, periodicity, prodIds } = formValues;

  const { totalProdIds } = totalValues;

  const rsrc = useRsrc();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (!invPeriodId) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    const reqParam = {
      periodId: invPeriodId,
      prodIds,
      prodIdsNot
    };

    rsrc.data('sc', 'DIR_SALE_TREND_GRAPH_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [invPeriodId, periodicity, prodIds]);

  return (
    <>
        <CartesianChart
          data={data}
          yLabel={'Sales Dollars'}
          xLabel="Invoice Period"
          legend="top"
        />
    </>

  );
};
